/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ConsortiumRole = {
    SOLE_LE: 'SOLE_LE',
    VOTING_CONSORTIUM_MEMBER: 'VOTING_CONSORTIUM_MEMBER',
    NON_VOTING_CONSORTIUM_MEMBER: 'NON_VOTING_CONSORTIUM_MEMBER'
} as const;
export type ConsortiumRole = typeof ConsortiumRole[keyof typeof ConsortiumRole];


export function ConsortiumRoleFromJSON(json: any): ConsortiumRole {
    return ConsortiumRoleFromJSONTyped(json, false);
}

export function ConsortiumRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsortiumRole {
    return json as ConsortiumRole;
}

export function ConsortiumRoleToJSON(value?: ConsortiumRole | null): any {
    return value as any;
}

